import { render, staticRenderFns } from "./SlipperyRating.vue?vue&type=template&id=085b0f40"
import script from "./SlipperyRating.vue?vue&type=script&lang=js"
export * from "./SlipperyRating.vue?vue&type=script&lang=js"
import style0 from "./SlipperyRating.vue?vue&type=style&index=0&id=085b0f40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports